/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RollBonus = {
    Crit: 'crit',
    Fumble: 'fumble',
    Normal: 'normal'
} as const;
export type RollBonus = typeof RollBonus[keyof typeof RollBonus];

